<app-tab-toolbar [tabId]="'votingResults'" [selectedYear]="selectedYear" [saveDisabled]="!hasChanges"
  [showKeywordsToggle]="true" [keywordsVisible]="showKeywords"
  (keywordsVisibleChange)="showKeywords = $event"
  (yearChange)="onYearChange($event)" (save)="onSave()">
  @if (showYearWarning) {
    <div class="year-warning">
      <mat-icon>warning</mat-icon>
      <span>There is no data for the selected year</span>
    </div>
  }
</app-tab-toolbar>

<div class="voting-content">

  <!-- Meeting Details: Ordinary & Special side by side -->
  <div class="meeting-sections">
    <!-- Ordinary (meetingType = 1) -->
    <div class="board-section meeting-section" [formGroup]="ordinaryForm" [appReadOnlyTab]="'votingResults'">
      <h3 class="section-title">Ordinary</h3>
      <div class="meeting-fields">
        <div class="meeting-field">
          <label>Meeting Date</label>
          <input type="text" formControlName="meetingDate" class="ht-input ht-date-input"
                 maxlength="10" placeholder="dd/mm/yyyy" (input)="onDateInput($event)">
        </div>
        <div class="meeting-field">
          <label>Meeting Type</label>
          <select formControlName="meetingType" class="ht-select">
            <option value=""></option>
            <option value="1">Annual</option>
            <option value="2">Special</option>
          </select>
        </div>
        <div class="meeting-field">
          <label>Meeting Disclosure Status</label>
          <select formControlName="disclosureStatus" class="ht-select">
            <option value=""></option>
            <option value="1">Full</option>
            <option value="2">Partial</option>
            <option value="3">Not Disclosed</option>
          </select>
        </div>
        <div class="meeting-field-group">
          <div class="meeting-field">
            <label>Capital Represented Shares</label>
            <input type="text" inputmode="numeric" appNumberFormat formControlName="capitalRepresentedShares" class="ht-input">
          </div>
          <div class="meeting-field meeting-field-pct">
            <label>%</label>
            <input type="text" inputmode="numeric" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="capitalRepresentedSharesPct" class="ht-input">
          </div>
        </div>
        <div class="meeting-field-group">
          <div class="meeting-field">
            <label>Votes Represented Shares</label>
            <input type="text" inputmode="numeric" appNumberFormat formControlName="votesRepresentedShares" class="ht-input">
          </div>
          <div class="meeting-field meeting-field-pct">
            <label>%</label>
            <input type="text" inputmode="numeric" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="votesRepresentedSharesPct" class="ht-input">
          </div>
        </div>
      </div>
    </div>

    <!-- Special (meetingType = 2) -->
    <div class="board-section meeting-section" [formGroup]="specialForm" [appReadOnlyTab]="'votingResults'">
      <h3 class="section-title">Special</h3>
      <div class="meeting-fields">
        <div class="meeting-field">
          <label>Meeting Date</label>
          <input type="text" formControlName="meetingDate" class="ht-input ht-date-input"
                 maxlength="10" placeholder="dd/mm/yyyy" (input)="onDateInput($event)">
        </div>
        <div class="meeting-field">
          <label>Meeting Type</label>
          <select formControlName="meetingType" class="ht-select">
            <option value=""></option>
            <option value="1">Annual</option>
            <option value="2">Special</option>
          </select>
        </div>
        <div class="meeting-field">
          <label>Meeting Disclosure Status</label>
          <select formControlName="disclosureStatus" class="ht-select">
            <option value=""></option>
            <option value="1">Full</option>
            <option value="2">Partial</option>
            <option value="3">Not Disclosed</option>
          </select>
        </div>
        <div class="meeting-field-group">
          <div class="meeting-field">
            <label>Capital Represented Shares</label>
            <input type="text" inputmode="numeric" appNumberFormat formControlName="capitalRepresentedShares" class="ht-input">
          </div>
          <div class="meeting-field meeting-field-pct">
            <label>%</label>
            <input type="text" inputmode="numeric" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="capitalRepresentedSharesPct" class="ht-input">
          </div>
        </div>
        <div class="meeting-field-group">
          <div class="meeting-field">
            <label>Votes Represented Shares</label>
            <input type="text" inputmode="numeric" appNumberFormat formControlName="votesRepresentedShares" class="ht-input">
          </div>
          <div class="meeting-field meeting-field-pct">
            <label>%</label>
            <input type="text" inputmode="numeric" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="votesRepresentedSharesPct" class="ht-input">
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Issue Table -->
  <div class="board-section">
    <h3 class="section-title">Issue</h3>

    @if (issueDataSource.data.length === 0) {
      <div class="no-data-message">No data available</div>
    } @else {
      <div class="table-wrapper" [formGroup]="issueRowsForm" [appReadOnlyTab]="'votingResults'">
        <table mat-table [dataSource]="issueDataSource" class="board-table" formArrayName="rows">

          <!-- Select -->
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let row" class="cell-select" (click)="toggleRowHighlight(row)">-</td>
          </ng-container>

          <!-- Vote Type -->
          <ng-container matColumnDef="voteType">
            <th mat-header-cell *matHeaderCellDef>Type</th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
              <select formControlName="voteType" class="ht-select" [title]="getVoteTypeLabel(row.voteType)">
                <option value=""></option>
                <option value="1" title="O">O</option>
                <option value="2" title="S">S</option>
              </select>
            </td>
          </ng-container>

          <!-- Vote Rank -->
          <ng-container matColumnDef="voteRank">
            <th mat-header-cell *matHeaderCellDef>#</th>
            <td mat-cell *matCellDef="let row; let i = index"
                [class.election-parent-cell]="isElectionParentRow(i)">
              @if (isElectionParentRow(i)) {
                <div class="rank-hover-container">
                  <span class="display-rank rank-hover-text">{{ getDisplayRank(i) }}</span>
                  @if (!isReadOnly()) {
                    <button mat-icon-button class="rank-hover-btn"
                            (click)="onOpenElectionDialog(i)"
                            matTooltip="Manage director elections">
                      <mat-icon>more_horiz</mat-icon>
                    </button>
                  }
                </div>
              } @else {
                <span class="display-rank">{{ getDisplayRank(i) }}</span>
              }
            </td>
          </ng-container>

          <!-- Issue -->
          <ng-container matColumnDef="issue">
            <th mat-header-cell *matHeaderCellDef>Issue</th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
              <input type="text" formControlName="issue" class="ht-input ht-text-input"
                     [class.ht-cell-invalid]="issueRows.at(i).get('issue')?.invalid" [title]="row.issue || ''">
            </td>
          </ng-container>

          <!-- Category -->
          <ng-container matColumnDef="category">
            <th mat-header-cell *matHeaderCellDef>Category</th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
              <select formControlName="categoryId" class="ht-select"
                      [class.ht-cell-invalid]="issueRows.at(i).get('categoryId')?.invalid" [title]="getCategoryName(row.categoryId)">
                <option value=""></option>
                @for (cat of parentCategories; track cat.id) {
                  <option [value]="cat.id" [title]="cat.name">{{ cat.name }}</option>
                }
              </select>
            </td>
          </ng-container>

          <!-- Subcategory -->
          <ng-container matColumnDef="subcategory">
            <th mat-header-cell *matHeaderCellDef>Subcategory</th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
              <select formControlName="subcategoryId" class="ht-select"
                      [class.ht-cell-invalid]="issueRows.at(i).get('subcategoryId')?.invalid" [title]="getSubcategoryName(row.subcategoryId)">
                <option value=""></option>
                @for (sub of getSubcategoriesForRow(issueRows.at(i).value.categoryId); track sub.id) {
                  <option [value]="sub.id" [title]="sub.name">{{ sub.name }}</option>
                }
              </select>
            </td>
          </ng-container>

          <!-- Vote Requirement -->
          <ng-container matColumnDef="requirement">
            <th mat-header-cell *matHeaderCellDef>Vote Reqmt.</th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
              <select formControlName="requirementId" class="ht-select" [title]="getOptionName(voteRequirementOptions, row.requirementId)">
                <option value=""></option>
                @for (opt of voteRequirementOptions; track opt.id) {
                  <option [value]="opt.id" [title]="opt.name">{{ opt.name }}</option>
                }
              </select>
            </td>
          </ng-container>

          <!-- Shareholder Proposal -->
          <ng-container matColumnDef="shareholderProposal">
            <th mat-header-cell *matHeaderCellDef>Sh. Prop.</th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
              <select formControlName="isShareholderProposal" class="ht-select" [title]="getShareholderProposalLabel(row.isShareholderProposal)">
                <option value=""></option>
                <option value="true" title="Yes">Yes</option>
                <option value="false" title="No">No</option>
              </select>
            </td>
          </ng-container>

          <!-- Proposal Name -->
          <ng-container matColumnDef="proposalName">
            <th mat-header-cell *matHeaderCellDef>Proposal Name</th>
            <td mat-cell *matCellDef="let row; let i = index" class="cell-proposal-name">
              <div class="proposal-name-cell">
                <span class="proposal-name-text" [class.has-name]="hasProposalName('issue', i)"
                      [title]="getProposalDisplayName('issue', i, row)">
                  {{ getProposalDisplayName('issue', i, row) }}
                </span>
                @if (!isReadOnly()) {
                  <button mat-icon-button class="proposal-btn"
                          (click)="onOpenProposalNameDialog('issue', i)"
                          [disabled]="!isShareholderProposal('issue', i)"
                          matTooltip="Select proposal name">
                    <mat-icon>more_horiz</mat-icon>
                  </button>
                  @if (hasProposalName('issue', i)) {
                    <button mat-icon-button class="proposal-btn proposal-clear-btn"
                            (click)="onClearProposalName('issue', i)"
                            matTooltip="Clear proposal name">
                      <mat-icon>close</mat-icon>
                    </button>
                  }
                }
              </div>
            </td>
          </ng-container>

          <!-- Board Vote Recommendation -->
          <ng-container matColumnDef="boardVoteRec">
            <th mat-header-cell *matHeaderCellDef>Board Vote Rec.</th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
              <select formControlName="boardVoteRecommendationId" class="ht-select" [title]="getOptionName(boardVoteRecOptions, row.boardVoteRecommendationId)">
                <option value=""></option>
                @for (opt of boardVoteRecOptions; track opt.id) {
                  <option [value]="opt.id" [title]="opt.name">{{ opt.name }}</option>
                }
              </select>
            </td>
          </ng-container>

          <!-- For Votes -->
          <ng-container matColumnDef="forVotes">
            <th mat-header-cell *matHeaderCellDef>For Votes</th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
              <input type="text" inputmode="numeric" appNumberFormat formControlName="forVotes" class="ht-input">
            </td>
          </ng-container>

          <!-- For % -->
          <ng-container matColumnDef="forVotesPct">
            <th mat-header-cell *matHeaderCellDef>%</th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
              <input type="text" inputmode="numeric" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="forVotesPct" class="ht-input">
            </td>
          </ng-container>

          <!-- Against Votes -->
          <ng-container matColumnDef="againstVotes">
            <th mat-header-cell *matHeaderCellDef>Against Votes</th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
              <input type="text" inputmode="numeric" appNumberFormat formControlName="againstVotes" class="ht-input">
            </td>
          </ng-container>

          <!-- Against % -->
          <ng-container matColumnDef="againstVotesPct">
            <th mat-header-cell *matHeaderCellDef>%</th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
              <input type="text" inputmode="numeric" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="againstVotesPct" class="ht-input">
            </td>
          </ng-container>

          <!-- Abstain Votes -->
          <ng-container matColumnDef="abstainVotes">
            <th mat-header-cell *matHeaderCellDef>Abstain Votes</th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
              <input type="text" inputmode="numeric" appNumberFormat formControlName="abstainVotes" class="ht-input">
            </td>
          </ng-container>

          <!-- Vote Withheld -->
          <ng-container matColumnDef="voteWithheld">
            <th mat-header-cell *matHeaderCellDef>Vote Withheld</th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
              <input type="text" inputmode="numeric" appNumberFormat formControlName="voteWithheld" class="ht-input">
            </td>
          </ng-container>

          <!-- Broker NonVote -->
          <ng-container matColumnDef="brokerNonVote">
            <th mat-header-cell *matHeaderCellDef>Broker NonVote</th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
              <input type="text" inputmode="numeric" appNumberFormat formControlName="brokerNonVote" class="ht-input">
            </td>
          </ng-container>

          <!-- Total Votes -->
          <ng-container matColumnDef="totalVotes">
            <th mat-header-cell *matHeaderCellDef>Total Votes</th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
              <input type="text" inputmode="numeric" appNumberFormat formControlName="totalVotes" class="ht-input ht-readonly" readonly>
            </td>
          </ng-container>

          <!-- Vote Result -->
          <ng-container matColumnDef="voteResult">
            <th mat-header-cell *matHeaderCellDef>Vote Result</th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
              <select formControlName="voteResultId" class="ht-select" [title]="getOptionName(voteResultOptions, row.voteResultId)">
                <option value=""></option>
                @for (opt of voteResultOptions; track opt.id) {
                  <option [value]="opt.id" [title]="opt.name">{{ opt.name }}</option>
                }
              </select>
            </td>
          </ng-container>

          <!-- Decided By -->
          <ng-container matColumnDef="decidedBy">
            <th mat-header-cell *matHeaderCellDef>Decided By</th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
              <select formControlName="decidedById" class="ht-select" [title]="getOptionName(decidedByOptions, row.decidedById)">
                <option value=""></option>
                @for (opt of decidedByOptions; track opt.id) {
                  <option [value]="opt.id" [title]="opt.name">{{ opt.name }}</option>
                }
              </select>
            </td>
          </ng-container>

          <!-- Delete -->
          <ng-container matColumnDef="delete">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let row; let i = index">
              @if (!isReadOnly()) {
                <button mat-icon-button color="warn" (click)="onDeleteIssue(row, i)" class="delete-btn">
                  <mat-icon>delete</mat-icon>
                </button>
              }
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="issueDisplayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: issueDisplayedColumns;" [class.new-row]="!row.id" [class.row-highlighted]="row.highlighted"></tr>
        </table>
      </div>
    }

    @if (!isReadOnly()) {
      <div class="table-actions">
        <button mat-raised-button color="primary" (click)="onAddIssue()">Add</button>
        @if (selectedIssueRows.length > 0) {
          <button mat-raised-button color="primary" type="button" class="nrg-destructive-primary-button" (click)="onDeleteSelectedIssues()">
            <mat-icon>delete</mat-icon>
            Delete selected ({{ selectedIssueRows.length }})
          </button>
        }
      </div>
    }
  </div>

  @if (showKeywords) {
    <div class="keywords-section" [formGroup]="keywordsForm" [appReadOnlyTab]="'votingResults'">
      <div class="section-header"><span>Keywords</span></div>
      <div class="keywords-fields"><app-keyword-input name="votingResults" label="Voting Results" /></div>
    </div>
  }

  <!-- Say on Pay Table -->
  <div class="board-section">
    <h3 class="section-title">Say on Pay</h3>

    @if (sayOnPayDataSource.data.length === 0) {
      <div class="no-data-message">No data available</div>
    } @else {
      <div class="table-wrapper" [formGroup]="sayOnPayRowsForm" [appReadOnlyTab]="'votingResults'">
        <table mat-table [dataSource]="sayOnPayDataSource" class="board-table" formArrayName="rows">

          <!-- Select -->
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let row" class="cell-select" (click)="toggleRowHighlight(row)">-</td>
          </ng-container>

          <!-- Vote Type -->
          <ng-container matColumnDef="voteType">
            <th mat-header-cell *matHeaderCellDef>Type</th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
              <select formControlName="voteType" class="ht-select" [title]="getVoteTypeLabel(row.voteType)">
                <option value=""></option>
                <option value="1" title="O">O</option>
                <option value="2" title="S">S</option>
              </select>
            </td>
          </ng-container>

          <!-- Vote Rank -->
          <ng-container matColumnDef="voteRank">
            <th mat-header-cell *matHeaderCellDef>#</th>
            <td mat-cell *matCellDef="let row; let i = index">
              <span class="display-rank">{{ getSayOnPayDisplayRank(i) }}</span>
            </td>
          </ng-container>

          <!-- Issue -->
          <ng-container matColumnDef="issue">
            <th mat-header-cell *matHeaderCellDef>Issue</th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
              <input type="text" formControlName="issue" class="ht-input ht-text-input"
                     [class.ht-cell-invalid]="sayOnPayRows.at(i).get('issue')?.invalid" [title]="row.issue || ''">
            </td>
          </ng-container>

          <!-- Category -->
          <ng-container matColumnDef="category">
            <th mat-header-cell *matHeaderCellDef>Category</th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
              <select formControlName="categoryId" class="ht-select"
                      [class.ht-cell-invalid]="sayOnPayRows.at(i).get('categoryId')?.invalid" [title]="getCategoryName(row.categoryId)">
                <option value=""></option>
                @for (cat of parentCategories; track cat.id) {
                  <option [value]="cat.id" [title]="cat.name">{{ cat.name }}</option>
                }
              </select>
            </td>
          </ng-container>

          <!-- Subcategory -->
          <ng-container matColumnDef="subcategory">
            <th mat-header-cell *matHeaderCellDef>Subcategory</th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
              <select formControlName="subcategoryId" class="ht-select"
                      [class.ht-cell-invalid]="sayOnPayRows.at(i).get('subcategoryId')?.invalid" [title]="getSubcategoryName(row.subcategoryId)">
                <option value=""></option>
                @for (sub of getSubcategoriesForRow(sayOnPayRows.at(i).value.categoryId); track sub.id) {
                  <option [value]="sub.id" [title]="sub.name">{{ sub.name }}</option>
                }
              </select>
            </td>
          </ng-container>

          <!-- Vote Requirement -->
          <ng-container matColumnDef="requirement">
            <th mat-header-cell *matHeaderCellDef>Vote Reqmt.</th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
              <select formControlName="requirementId" class="ht-select" [title]="getOptionName(voteRequirementOptions, row.requirementId)">
                <option value=""></option>
                @for (opt of voteRequirementOptions; track opt.id) {
                  <option [value]="opt.id" [title]="opt.name">{{ opt.name }}</option>
                }
              </select>
            </td>
          </ng-container>

          <!-- Shareholder Proposal -->
          <ng-container matColumnDef="shareholderProposal">
            <th mat-header-cell *matHeaderCellDef>Sh. Prop.</th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
              <select formControlName="isShareholderProposal" class="ht-select" [title]="getShareholderProposalLabel(row.isShareholderProposal)">
                <option value=""></option>
                <option value="true" title="Yes">Yes</option>
                <option value="false" title="No">No</option>
              </select>
            </td>
          </ng-container>

          <!-- Proposal Name -->
          <ng-container matColumnDef="proposalName">
            <th mat-header-cell *matHeaderCellDef>Proposal Name</th>
            <td mat-cell *matCellDef="let row; let i = index" class="cell-proposal-name">
              <div class="proposal-name-cell">
                <span class="proposal-name-text" [class.has-name]="hasProposalName('sayOnPay', i)"
                      [title]="getProposalDisplayName('sayOnPay', i, row)">
                  {{ getProposalDisplayName('sayOnPay', i, row) }}
                </span>
                @if (!isReadOnly()) {
                  <button mat-icon-button class="proposal-btn"
                          (click)="onOpenProposalNameDialog('sayOnPay', i)"
                          [disabled]="!isShareholderProposal('sayOnPay', i)"
                          matTooltip="Select proposal name">
                    <mat-icon>more_horiz</mat-icon>
                  </button>
                  @if (hasProposalName('sayOnPay', i)) {
                    <button mat-icon-button class="proposal-btn proposal-clear-btn"
                            (click)="onClearProposalName('sayOnPay', i)"
                            matTooltip="Clear proposal name">
                      <mat-icon>close</mat-icon>
                    </button>
                  }
                }
              </div>
            </td>
          </ng-container>

          <!-- Board Vote Recommendation -->
          <ng-container matColumnDef="boardVoteRec">
            <th mat-header-cell *matHeaderCellDef>Board Vote Rec.</th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
              <select formControlName="boardVoteRecommendationId" class="ht-select" [title]="getOptionName(boardVoteRecOptions, row.boardVoteRecommendationId)">
                <option value=""></option>
                @for (opt of boardVoteRecOptions; track opt.id) {
                  <option [value]="opt.id" [title]="opt.name">{{ opt.name }}</option>
                }
              </select>
            </td>
          </ng-container>

          <!-- For Votes -->
          <ng-container matColumnDef="forVotes">
            <th mat-header-cell *matHeaderCellDef>For Votes</th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
              <input type="text" inputmode="numeric" appNumberFormat formControlName="forVotes" class="ht-input">
            </td>
          </ng-container>

          <!-- For % -->
          <ng-container matColumnDef="forVotesPct">
            <th mat-header-cell *matHeaderCellDef>%</th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
              <input type="text" inputmode="numeric" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="forVotesPct" class="ht-input">
            </td>
          </ng-container>

          <!-- 1 Year Votes -->
          <ng-container matColumnDef="firstYearVotes">
            <th mat-header-cell *matHeaderCellDef>1 Year Votes</th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
              <input type="text" inputmode="numeric" appNumberFormat formControlName="firstYearVotes" class="ht-input">
            </td>
          </ng-container>

          <!-- 1 Year % -->
          <ng-container matColumnDef="firstYearVotesPct">
            <th mat-header-cell *matHeaderCellDef>1%</th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
              <input type="text" inputmode="numeric" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="firstYearVotesPct" class="ht-input">
            </td>
          </ng-container>

          <!-- 2 Years Votes -->
          <ng-container matColumnDef="secondYearVotes">
            <th mat-header-cell *matHeaderCellDef>2 Years Votes</th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
              <input type="text" inputmode="numeric" appNumberFormat formControlName="secondYearVotes" class="ht-input">
            </td>
          </ng-container>

          <!-- 2 Years % -->
          <ng-container matColumnDef="secondYearVotesPct">
            <th mat-header-cell *matHeaderCellDef>2%</th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
              <input type="text" inputmode="numeric" appNumberFormat [decimals]="2" formControlName="secondYearVotesPct" class="ht-input">
            </td>
          </ng-container>

          <!-- 3 Years Votes -->
          <ng-container matColumnDef="thirdYearVotes">
            <th mat-header-cell *matHeaderCellDef>3 Years Votes</th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
              <input type="text" inputmode="numeric" appNumberFormat formControlName="thirdYearVotes" class="ht-input">
            </td>
          </ng-container>

          <!-- 3 Years % -->
          <ng-container matColumnDef="thirdYearVotesPct">
            <th mat-header-cell *matHeaderCellDef>3%</th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
              <input type="text" inputmode="numeric" appNumberFormat [decimals]="2" formControlName="thirdYearVotesPct" class="ht-input">
            </td>
          </ng-container>

          <!-- Against Votes -->
          <ng-container matColumnDef="againstVotes">
            <th mat-header-cell *matHeaderCellDef>Against Votes</th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
              <input type="text" inputmode="numeric" appNumberFormat formControlName="againstVotes" class="ht-input">
            </td>
          </ng-container>

          <!-- Against % -->
          <ng-container matColumnDef="againstVotesPct">
            <th mat-header-cell *matHeaderCellDef>%</th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
              <input type="text" inputmode="numeric" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="againstVotesPct" class="ht-input">
            </td>
          </ng-container>

          <!-- Abstain Votes -->
          <ng-container matColumnDef="abstainVotes">
            <th mat-header-cell *matHeaderCellDef>Abstain Votes</th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
              <input type="text" inputmode="numeric" appNumberFormat formControlName="abstainVotes" class="ht-input">
            </td>
          </ng-container>

          <!-- Vote Withheld -->
          <ng-container matColumnDef="voteWithheld">
            <th mat-header-cell *matHeaderCellDef>Vote Withheld</th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
              <input type="text" inputmode="numeric" appNumberFormat formControlName="voteWithheld" class="ht-input">
            </td>
          </ng-container>

          <!-- Broker NonVote -->
          <ng-container matColumnDef="brokerNonVote">
            <th mat-header-cell *matHeaderCellDef>Broker NonVote</th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
              <input type="text" inputmode="numeric" appNumberFormat formControlName="brokerNonVote" class="ht-input">
            </td>
          </ng-container>

          <!-- Total Votes -->
          <ng-container matColumnDef="totalVotes">
            <th mat-header-cell *matHeaderCellDef>Total Votes</th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
              <input type="text" inputmode="numeric" appNumberFormat formControlName="totalVotes" class="ht-input ht-readonly" readonly>
            </td>
          </ng-container>

          <!-- Vote Result -->
          <ng-container matColumnDef="voteResult">
            <th mat-header-cell *matHeaderCellDef>Vote Result</th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
              <select formControlName="voteResultId" class="ht-select" [title]="getOptionName(voteResultOptions, row.voteResultId)">
                <option value=""></option>
                @for (opt of voteResultOptions; track opt.id) {
                  <option [value]="opt.id" [title]="opt.name">{{ opt.name }}</option>
                }
              </select>
            </td>
          </ng-container>

          <!-- Decided By -->
          <ng-container matColumnDef="decidedBy">
            <th mat-header-cell *matHeaderCellDef>Decided By</th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
              <select formControlName="decidedById" class="ht-select" [title]="getOptionName(decidedByOptions, row.decidedById)">
                <option value=""></option>
                @for (opt of decidedByOptions; track opt.id) {
                  <option [value]="opt.id" [title]="opt.name">{{ opt.name }}</option>
                }
              </select>
            </td>
          </ng-container>

          <!-- Delete -->
          <ng-container matColumnDef="delete">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let row; let i = index">
              @if (!isReadOnly()) {
                <button mat-icon-button color="warn" (click)="onDeleteSayOnPay(row, i)" class="delete-btn">
                  <mat-icon>delete</mat-icon>
                </button>
              }
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="sayOnPayDisplayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: sayOnPayDisplayedColumns;" [class.new-row]="!row.id" [class.row-highlighted]="row.highlighted"></tr>
        </table>
      </div>
    }

    @if (!isReadOnly()) {
      <div class="table-actions">
        <button mat-raised-button color="primary" (click)="onAddSayOnPay()">Add</button>
        @if (selectedSayOnPayRows.length > 0) {
          <button mat-raised-button color="primary" type="button" class="nrg-destructive-primary-button" (click)="onDeleteSelectedSayOnPay()">
            <mat-icon>delete</mat-icon>
            Delete selected ({{ selectedSayOnPayRows.length }})
          </button>
        }
      </div>
    }
  </div>

  <!-- Comments -->
  <section class="section-container nrg-border-radius-second-level comments-section" [formGroup]="commentsForm" [appReadOnlyTab]="'votingResults'">
    <div class="section-header">
      <span>Comments</span>
    </div>
    <div class="section-content">
      <mat-form-field appearance="fill" class="form-field">
        <mat-label>Comments</mat-label>
        <textarea matInput formControlName="comments" rows="3"></textarea>
      </mat-form-field>
    </div>
  </section>

</div>
